import React from 'react';
import { InputField } from '../InputField';
import { SignupFormData, FormErrors } from '../../types';

interface PersonalInfoStepProps {
  formData: SignupFormData;
  errors: FormErrors;
  updateField: (field: keyof SignupFormData, value: string | boolean) => void;
  onNext: () => void;
  onStepComplete?: (stepName: string) => void;
}

export const PersonalInfoStep: React.FC<PersonalInfoStepProps> = ({
  formData,
  errors,
  updateField,
  onNext,
  onStepComplete,
}) => {
  const isStepValid = () => {
    return (
      formData.firstName &&
      formData.lastName &&
      !errors.firstName &&
      !errors.lastName
    );
  };

  const handleNext = () => {
    if (isStepValid()) {
      // Track step completion in HubSpot
      if (onStepComplete) {
        onStepComplete('personal_info');
      }
      onNext();
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-gray-900 mb-3">
          Let's get your firm set up{process.env.REACT_APP_ENVIRONMENT !== 'production' && process.env.REACT_APP_NAME ? ` (${process.env.REACT_APP_NAME})` : ''}
        </h1>
        <p className="text-gray-600">
          We'll collect a few details to create your company account and help you start managing cases with ease.
        </p>
      </div>

      <div className="space-y-4">
        <InputField
          id="firstName"
          name="firstName"
          label="First name"
          value={formData.firstName}
          onChange={(value) => updateField('firstName', value)}
          error={errors.firstName}
          required
          placeholder="e.g. Sarah"
        />

        <InputField
          id="lastName"
          name="lastName"
          label="Last name"
          value={formData.lastName}
          onChange={(value) => updateField('lastName', value)}
          error={errors.lastName}
          required
          placeholder="e.g. Aspinall"
        />
      </div>

      <div className="flex justify-between pt-6">
        <button
          type="button"
          className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors opacity-50 cursor-not-allowed"
          disabled
        >
          Previous
        </button>
        
        <button
          type="button"
          onClick={handleNext}
          disabled={!isStepValid()}
          className="px-8 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          Continue
        </button>
      </div>
    </div>
  );
};
